import { httpsCallable } from 'firebase/functions';
import { getFunctionsOrThrow } from './firebase';
import type { EventType, MusicId, PackageId, PhotoRef, StyleId } from './types';

export interface CreateMomentJobReq {
  eventType: EventType;
}
export interface CreateMomentJobRes {
  jobId: string;
  uploadPrefix: string;
}

export interface SetJobChoicesReq {
  jobId: string;
  styleId?: StyleId;
  musicId?: MusicId;
  pkg?: PackageId;
  photos?: PhotoRef[];
}
export interface SetJobChoicesRes {
  ok: true;
}

export interface StartGenerationReq {
  jobId: string;
}
export interface StartGenerationRes {
  ok: true;
}

export interface DeleteMomentJobReq {
  jobId: string;
}
export interface DeleteMomentJobRes {
  ok: true;
}

export interface MeshulamCreateCheckoutReq {
  jobId: string;
  pkg: PackageId;
  buyer: { fullName: string; phone?: string; email?: string };
}
export interface MeshulamCreateCheckoutRes {
  url: string;
  processId: string;
}

export interface SignDownloadUrlReq {
  jobId: string;
}
export interface SignDownloadUrlRes {
  url: string;
  expiresAt: number;
}

function call<TReq, TRes>(name: string) {
  return async (data: TReq): Promise<TRes> => {
    const fn = httpsCallable<TReq, TRes>(getFunctionsOrThrow(), name);
    const res = await fn(data);
    return res.data;
  };
}

export const api = {
  createMomentJob: call<CreateMomentJobReq, CreateMomentJobRes>(
    'createMomentJob',
  ),
  setJobChoices: call<SetJobChoicesReq, SetJobChoicesRes>('setJobChoices'),
  startGeneration: call<StartGenerationReq, StartGenerationRes>(
    'startGeneration',
  ),
  deleteMomentJob: call<DeleteMomentJobReq, DeleteMomentJobRes>(
    'deleteMomentJob',
  ),
  meshulamCreateCheckout: call<
    MeshulamCreateCheckoutReq,
    MeshulamCreateCheckoutRes
  >('meshulamCreateCheckout'),
  signDownloadUrl: call<SignDownloadUrlReq, SignDownloadUrlRes>(
    'signDownloadUrl',
  ),
};
